import React, { FC, useState } from 'react';
import { toast } from 'react-toastify';
import {
  GxForm,
  GxButton,
  GxSpinner,
} from '@garpix/garpix-web-components-react';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import ModalLayout from '../../../../components/ModalLayout';
import { IModalInvoice } from './interfaces';

import styles from './styles/index.module.scss';

export const ModalExitChange: FC<IModalInvoice> = ({ props, flag, onRequestClose }) => {
  const { exit_time, onChangeExitTime } = props;
  const [statusLoad, setStatusLoad] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      exit_time: exit_time || dayjs().format('HH:mm')
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async ({ exit_time }) => {
      setStatusLoad(true);
      try {
        onChangeExitTime(exit_time);
      } catch {
        toast.error('Не удалось изменить данные выхода')
      } finally {
        setStatusLoad(false);
        onRequestClose();
      }
    }
  })

  return (
    <ModalLayout
      size='sm'
      flag={flag}
      onClose={onRequestClose}
    >
      <div className={styles['header']}>
        <h2 className={styles['header--title']}>Время выхода</h2>
      </div>
      <GxForm onGx-submit={formik.submitForm}>
        <div className={styles['main']}>
          <input
            type='time'
            name='exit_time'
            className={styles['time']}
            onChange={(e) => formik.setFieldValue('exit_time', e.target.value)}
            defaultValue={formik.values.exit_time}
          />
        </div>
        <div className={styles['footer']}>
          <div className={styles['footer--container']}>
            <GxButton type='button' className={styles['btn--close']} onClick={onRequestClose}>Отмена</GxButton>
            {statusLoad
              ? <GxSpinner style={{ fontSize: '2rem' }} />
              : <GxButton className={styles['btn--save']} type="submit">Ок</GxButton>
            }
          </div>
        </div>
      </GxForm>

    </ModalLayout>
  );
};
